export const of_transport_stops_displayed_columns_locale = {
  stopType: "Stop type",
  location: "Location",
  address: "Address",
  timestamp: "Date",
  reference: "Reference"
};
